import * as React from "react";
import { Entry } from "../models/entries";
import { UserContext } from "../state";
import { api } from "../api";
import { RouteComponentProps } from "react-router";
import { Compo } from "../models/compos";
import { API_EntryId } from "../../../src/apidefs";
import Tooltip from "../DesignSystem/Tooltip";
import { GoldCoin } from "../Toolbar/GoldCoin";
import { Button } from "../DesignSystem/Button";
import { TestIds } from "../testIds";
import { CollaboratorsInput } from "../DesignSystem/CollaboratorsInput";
import { SecretSantaInput } from "../DesignSystem/SecretSantaInput";

export const OptionalThemeExplainer = () => {
  return (
    <div>
      <div className="pb-[10px] text-[18px]">Themes are optional!</div>

      <div>Unticking this just means your entry won't be judged on theme.</div>
    </div>
  );
};

export const JudgedExplainer = () => {
  return (
    <div>
      <div className="pb-[10px] text-[18px]">Receive scores?</div>

      <div>
        If you uncheck this, you won't have to vote, and you will not receive
        any scores at the end of the compo.
      </div>

      <div>All unjudged submissions to a contest are free!</div>
    </div>
  );
};

export const JokeExplainer = () => {
  return (
    <div>
      <div className="pb-[10px] text-[18px]">Is this a joke track?</div>

      <div>If it is, it won't be voted on or played in the sync listen.</div>
    </div>
  );
};

interface EditEntryProps extends RouteComponentProps<{ id: string }> {}

interface EditEntryState {
  data?: API_EntryId;

  mod_comments: string;
  override_deadline: boolean;
  collaborators: string[];
  uploadedUrl: string;

  update_state: "never" | "updating" | "done";

  // Secret Santa fields
  isSecretSantaTrack: boolean;
  secretSantaRecipient: string;
  secretSantaPromptText: string;
}

export class EditEntryPage extends React.Component<
  EditEntryProps,
  EditEntryState
> {
  static contextType = UserContext;
  declare context: React.ContextType<typeof UserContext>;

  downloadable: HTMLInputElement | undefined;
  submitButton: HTMLButtonElement | undefined;
  fileInput: HTMLInputElement | undefined;
  statusThing: HTMLSpanElement | undefined;
  url: HTMLInputElement | undefined;
  description: HTMLTextAreaElement | undefined;
  title: HTMLInputElement | undefined;

  state: EditEntryState = {
    update_state: "never",
    mod_comments: "",
    override_deadline: false,
    collaborators: ["", "", "", "", "", ""],
    uploadedUrl: "",
    data: undefined,
    isSecretSantaTrack: false,
    secretSantaRecipient: "",
    secretSantaPromptText: "",
  };

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  async componentWillReceiveProps(newProps: EditEntryProps): Promise<void> {
    const entry_id = newProps.match.params.id;
    const result = await api.get<"/api/entry/:id">(`/api/entry/${entry_id}`, {
      params: {
        deanon: true,
      },
    });

    if (api.isToast(result)) {
      return;
    }

    this.setState({
      data: result,
      mod_comments: result.entry.mod_comments,
      uploadedUrl: result.entry.uploaded_url || "",
      collaborators: [0, 1, 2, 3, 4, 5].map(
        (i) => result.unofficial_entry_users[i]?.username || ""
      ),
      isSecretSantaTrack: !!(
        result.entry.secret_santa_recipient_user_id ||
        result.entry.secret_santa_recipient_external_user_name
      ),
      secretSantaRecipient:
        result.secret_santa_recipient?.username ||
        result.entry.secret_santa_recipient_external_user_name ||
        "",
      secretSantaPromptText: result.entry.secret_santa_prompt_text || "",
    });
  }

  async submit(): Promise<void> {
    if (
      !this.title ||
      !this.description ||
      !this.downloadable ||
      !this.state.data
    ) {
      return;
    }

    this.setState({ update_state: "updating" });

    console.log("submit", this.state.uploadedUrl);

    await api.post<"/api/entry/:id/edit">(
      `/api/entry/${this.state.data.entry.id}/edit`,
      {
        title: this.title.value,
        description: this.description.value,
        uploaded_url: this.state.uploadedUrl,
        collaborator_0: this.state.collaborators[0],
        collaborator_1: this.state.collaborators[1],
        collaborator_2: this.state.collaborators[2],
        collaborator_3: this.state.collaborators[3],
        collaborator_4: this.state.collaborators[4],
        collaborator_5: this.state.collaborators[5],
        followed_theme: this.state.data.entry.followed_theme,
        is_judged: this.state.data.entry.is_judged,
        is_joke: this.state.data.entry.is_joke,
        downloadable: this.downloadable.checked ? "on" : "off",
        mod_comments: this.state.mod_comments,
        override_deadline: this.state.override_deadline,
        secret_santa_recipient:
          this.state.isSecretSantaTrack && this.state.secretSantaRecipient
            ? this.state.secretSantaRecipient
            : undefined,
        secret_santa_prompt_text:
          this.state.isSecretSantaTrack && this.state.secretSantaPromptText
            ? this.state.secretSantaPromptText
            : undefined,
      }
    );

    this.setState({ update_state: "done" });
  }

  render(): JSX.Element {
    if (!this.state.data || !this.state.data.compo) {
      return (
        <div className="mx-auto max-w-4xl px-4 py-16">
          <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm dark:border-white/10 dark:bg-slate-900">
            <i
              className="fa fa-spinner fa-pulse fa-2x text-slate-400"
              aria-hidden="true"
            ></i>
            <p className="mt-4 text-slate-500 dark:text-slate-400">
              Loading...
            </p>
          </div>
        </div>
      );
    }

    const { user: userState } = this.context;

    // Still loading the user - show loading state
    if (userState.type === "loading") {
      return (
        <div className="mx-auto max-w-4xl px-4 py-16 text-center">
          <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm dark:border-white/10 dark:bg-slate-900">
            <i
              className="fa fa-spinner fa-pulse fa-2x text-slate-400"
              aria-hidden="true"
            ></i>
            <p className="mt-4 text-slate-500 dark:text-slate-400">
              Loading...
            </p>
          </div>
        </div>
      );
    }

    if (
      userState.type === "logged-out" ||
      (!userState.user.admin &&
        this.state.data.entry_users.filter((x) => x.id === userState.user.id)
          .length === 0)
    ) {
      return (
        <div className="mx-auto max-w-4xl px-4 py-16">
          <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm dark:border-white/10 dark:bg-slate-900">
            <p className="text-lg text-red-600 dark:text-red-400">
              That's not your song, bro.
            </p>
          </div>
        </div>
      );
    }

    // At this point userState is "logged-in"
    const user = userState.user;

    const compoObj = new Compo(this.state.data.compo);

    return (
      <div className="mx-auto max-w-4xl px-4 py-16">
        <div className="mb-8">
          <h1 className="text-4xl font-semibold text-slate-900 dark:text-white">
            Editing {this.state.data.entry.title}
          </h1>
          <p className="mt-2 text-slate-500 dark:text-slate-400">
            Submitted {new Entry(this.state.data.entry).created.toDateString()}
          </p>
        </div>

        <div className="space-y-6">
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-slate-900">
            <h3 className="mb-6 text-xl font-semibold text-slate-900 dark:text-white">
              Entry Information
            </h3>

            <div className="space-y-4">
              <div>
                <label className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-300">
                  Title:
                </label>
                <input
                  ref={(e) => {
                    if (e) this.title = e;
                  }}
                  type="text"
                  name="title"
                  defaultValue={this.state.data.entry.title}
                  className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2 text-slate-900 placeholder-slate-400 focus:border-chips-gold focus:outline-none focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10 dark:bg-slate-800 dark:text-white dark:placeholder-slate-500"
                />
              </div>

              <div>
                <label className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-300">
                  Description
                </label>
                <textarea
                  ref={(e) => {
                    if (e) this.description = e;
                  }}
                  name="description"
                  rows={6}
                  defaultValue={this.state.data.entry.description}
                  className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2 text-slate-900 placeholder-slate-400 focus:border-chips-gold focus:outline-none focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10 dark:bg-slate-800 dark:text-white dark:placeholder-slate-500"
                />
              </div>

              {user.admin && (
                <div>
                  <label className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-300">
                    Mod Comments
                  </label>
                  <textarea
                    name="mod_comments"
                    rows={4}
                    onChange={(e) =>
                      this.setState({ mod_comments: e.currentTarget.value })
                    }
                    value={this.state.mod_comments}
                    className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2 text-slate-900 placeholder-slate-400 focus:border-chips-gold focus:outline-none focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10 dark:bg-slate-800 dark:text-white dark:placeholder-slate-500"
                  />
                </div>
              )}

              <div className="flex items-center gap-2">
                <input
                  ref={(e) => {
                    if (e) this.downloadable = e;
                  }}
                  type="checkbox"
                  id="downloadable"
                  name="downloadable"
                  defaultChecked={this.state.data.entry.downloadable}
                  className="h-4 w-4 rounded border-slate-300 text-chips-gold focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10"
                />
                <label
                  htmlFor="downloadable"
                  className="text-sm text-slate-700 dark:text-slate-300"
                >
                  Allow downloads.
                </label>
              </div>

              <div className="flex items-center gap-2">
                <input
                  disabled={compoObj.state !== "entry"}
                  onChange={(e) => {
                    const followed_theme = e.currentTarget.checked;

                    this.setState((old) => {
                      if (!old.data) {
                        return old;
                      }

                      old.data.entry.followed_theme = followed_theme;

                      return old;
                    });
                  }}
                  type="checkbox"
                  id="followed_theme"
                  name="followed_theme"
                  defaultChecked={this.state.data.entry.followed_theme}
                  className="h-4 w-4 rounded border-slate-300 text-chips-gold focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10"
                />

                <Tooltip
                  element={
                    <label
                      htmlFor="followed_theme"
                      className={`text-sm ${
                        compoObj.state !== "entry"
                          ? "text-slate-400 dark:text-slate-600"
                          : "text-slate-700 dark:text-slate-300"
                      }`}
                    >
                      I followed the theme.
                    </label>
                  }
                  tooltip={<OptionalThemeExplainer />}
                />
              </div>

              <div className="flex items-center gap-2">
                <input
                  disabled={!user.admin}
                  onChange={(e) => {
                    const is_joke = e.currentTarget.checked;

                    this.setState((old) => {
                      if (!old.data) {
                        return old;
                      }

                      old.data.entry.is_joke = is_joke;

                      return old;
                    });
                  }}
                  type="checkbox"
                  id="is_joke"
                  name="is_joke"
                  checked={this.state.data.entry.is_joke}
                  className="h-4 w-4 rounded border-slate-300 text-chips-gold focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10"
                />

                <Tooltip
                  element={
                    <label
                      htmlFor="is_joke"
                      className={`text-sm ${
                        compoObj.state !== "entry"
                          ? "text-slate-400 dark:text-slate-600"
                          : "text-slate-700 dark:text-slate-300"
                      }`}
                    >
                      This is a joke entry.
                    </label>
                  }
                  tooltip={<JokeExplainer />}
                />
              </div>

              <div className="flex items-center gap-2">
                <input
                  disabled={compoObj.state !== "entry"}
                  onChange={(e) => {
                    const is_judged = e.currentTarget.checked;

                    this.setState((old) => {
                      if (!old.data) {
                        return old;
                      }
                      if (old.data.entry.is_joke) {
                        return old;
                      }

                      old.data.entry.is_judged = is_judged;

                      return old;
                    });
                  }}
                  type="checkbox"
                  id="is_judged"
                  name="is_judged"
                  checked={this.state.data.entry.is_judged}
                  className="h-4 w-4 rounded border-slate-300 text-chips-gold focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10"
                />

                <Tooltip
                  element={
                    <label
                      htmlFor="is_judged"
                      className={`text-sm ${
                        compoObj.state !== "entry"
                          ? "text-slate-400 dark:text-slate-600"
                          : "text-slate-700 dark:text-slate-300"
                      }`}
                    >
                      I want to get scores.&nbsp;
                      {this.state.data.entry.is_judged &&
                        !this.state.data.compo.nogold &&
                        this.state.data.entryCounts![
                          this.state.data.entry.type
                        ] > 1 && (
                          <span>
                            +10 <GoldCoin />
                          </span>
                        )}
                      {!this.state.data.entry.is_judged &&
                        this.state.data.entryCounts![
                          this.state.data.entry.type
                        ] >= 1 && (
                          <span>
                            -10 <GoldCoin />
                          </span>
                        )}
                    </label>
                  }
                  tooltip={<JudgedExplainer />}
                />
              </div>

              {(new Compo(this.state.data.compo).state === "entry" ||
                user.admin) &&
              this.state.data.entry.type === "song" ? (
                <div>
                  <label className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-300">
                    <span
                      id="statusThing"
                      ref={(r) => {
                        if (r) this.statusThing = r;
                      }}
                    >
                      {this.state.data.entry.type === "song"
                        ? user.admin &&
                          this.state.data.entry_users.filter(
                            (x) => x.id === user!.id
                          ).length === 0
                          ? "Reupload this song:"
                          : "Reupload your song:"
                        : this.state.data.entry.type === "art"
                          ? user.admin &&
                            this.state.data.entry_users.filter(
                              (x) => x.id === user!.id
                            ).length === 0
                            ? "Reupload this art:"
                            : "Reupload your art:"
                          : ""}
                    </span>
                  </label>
                  <input
                    type="file"
                    id="file-input"
                    onChange={(_e) => this.changeFileInput()}
                    ref={(r) => {
                      if (r) this.fileInput = r;
                    }}
                    className="block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 file:mr-4 file:rounded-md file:border-0 file:bg-chips-gold file:px-4 file:py-2 file:text-sm file:font-semibold file:text-white hover:file:bg-amber-600 focus:border-chips-gold focus:outline-none focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10 dark:bg-slate-800 dark:text-white"
                  />
                </div>
              ) : null}

              {user.admin && (
                <div className="flex items-center gap-2 rounded-lg border border-violet-200 bg-violet-50 p-3 dark:border-violet-500/30 dark:bg-violet-900/20">
                  <input
                    onChange={(e) => {
                      this.setState({
                        override_deadline: e.currentTarget.checked,
                      });
                    }}
                    type="checkbox"
                    id="override_deadline"
                    name="override_deadline"
                    checked={this.state.override_deadline}
                    className="h-4 w-4 rounded border-slate-300 text-violet-600 focus:ring-2 focus:ring-violet-500/20 dark:border-white/10"
                  />
                  <label
                    htmlFor="override_deadline"
                    className="text-sm font-medium text-violet-900 dark:text-violet-200"
                  >
                    I am intentionally changing this entry after the deadline
                    (admin override)
                  </label>
                </div>
              )}
            </div>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-slate-900">
            <h3 className="mb-6 text-xl font-semibold text-slate-900 dark:text-white">
              Collaborators
            </h3>

            <CollaboratorsInput
              values={this.state.collaborators}
              onChange={(collaborators) => this.setState({ collaborators })}
              confirmations={
                new Entry(this.state.data!.entry).user_collab_confirmations
              }
            />
          </div>

          {this.state.data.compo.is_secret_santa && (
            <div className="rounded-2xl border-2 border-slate-600 bg-white p-6 shadow-sm dark:border-purple-300 dark:bg-slate-900">
              <SecretSantaInput
                isSecretSantaTrack={this.state.isSecretSantaTrack}
                onIsSecretSantaTrackChange={(value) =>
                  this.setState({ isSecretSantaTrack: value })
                }
                secretSantaRecipient={this.state.secretSantaRecipient}
                onSecretSantaRecipientChange={(value) =>
                  this.setState({ secretSantaRecipient: value })
                }
                secretSantaPromptText={this.state.secretSantaPromptText}
                onSecretSantaPromptTextChange={(value) =>
                  this.setState({ secretSantaPromptText: value })
                }
              />
            </div>
          )}

          <div className="flex items-center gap-6 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-slate-900">
            <button
              ref={(e) => {
                if (e) this.submitButton = e;
              }}
              onClick={() => this.submit()}
              data-testid={TestIds.UpdateEntryButton}
              className="inline-flex cursor-pointer items-center gap-2 rounded-lg bg-amber-500 px-6 py-3 font-semibold text-white transition hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-amber-500/20"
            >
              {this.state.update_state === "updating" && (
                <i className="fa fa-spinner fa-pulse" aria-hidden="true"></i>
              )}
              Update Entry
            </button>

            {this.state.update_state === "done" && (
              <span
                className="flex items-center gap-2 text-green-600 dark:text-green-400"
                data-testid={TestIds.UpdateEntrySaved}
              >
                <i className="fa fa-check" aria-hidden="true"></i>
                <span className="font-medium">Saved!</span>
              </span>
            )}

            <Button
              to={new Entry(this.state.data.entry).linkToEntry}
              variant="text"
              grow={false}
            >
              ← Return to entry page
            </Button>
          </div>
        </div>
      </div>
    );
  }

  changeFileInput(): void {
    if (!this.fileInput) {
      return;
    }

    const files = this.fileInput.files;
    const file = files && files[0];

    if (file == null) {
      return alert("No file selected.");
    }

    this.getSignedRequest(file);
  }

  getSignedRequest(file: File) {
    const xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      "/api/sign-s3?file-name=" + file.name + "&file-type=" + file.type
    );

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);

          this.uploadFile(file, response.signedRequest, response.url);
        } else {
          alert(
            "Upload failed for some reason. Ensure you're uploading an mp3."
          );
        }
      }
    };

    xhr.send();
  }

  uploadFile(file: File, signedRequest: string, url: string): void {
    if (!this.statusThing) {
      return;
    }

    const xhr = new XMLHttpRequest();

    this.statusThing.innerHTML = "Uploading... please wait!";

    xhr.open("PUT", signedRequest);

    xhr.onreadystatechange = () => {
      if (!this.statusThing || !this.submitButton) {
        return;
      }

      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          this.statusThing.innerHTML = "Done uploading!";
          this.setState({ uploadedUrl: url });
          this.submitButton.disabled = false;

          console.log("uploadFile", url);
        } else {
          this.statusThing.innerHTML = "Could not upload file.";
        }
      }
    };

    xhr.send(file);
  }
}
